import React from 'react'
import Link from 'gatsby-link'
import CalendarIcon from 'components/icons/Calendar'
import DocumentIcon from 'components/icons/Document'
import NavigateIcon from 'components/icons/Navigate'
import HeartIcon from 'components/icons/Heart'

const FeatureCard = ({
  icon: Icon,
  iconColor,
  title,
  description,
  link,
  linkText
}) => (
  <div
    className="flex-1 p-10 bg-white rounded-xl transition-all duration-200 hover:shadow-lg"
    style={{
      boxShadow:
        '0 7px 14px 0 rgba(50, 50, 93, 0.1), 0 3px 6px 0 rgba(0, 0, 0, 0.07)',
      border: '1px solid #e3e8ee'
    }}
  >
    <div
      style={{
        width: '56px',
        height: '56px',
        minWidth: '56px',
        minHeight: '56px',
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        marginBottom: '24px',
        background: `linear-gradient(135deg, ${iconColor} 0%, ${iconColor}dd 100%)`
      }}
    >
      <Icon fill="white" size="1.75rem" color="white" />
    </div>
    <h4 className="text-xl font-semibold text-navy mb-3">{title}</h4>
    <p className="text-base text-textSecondary leading-relaxed mb-4">
      {description}
    </p>
    {link && (
      <Link
        className="inline-flex items-center text-primary font-medium text-sm hover:text-primaryDark transition-colors duration-150"
        to={link}
      >
        {linkText}
        <svg
          className="w-4 h-4 ml-1"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M9 5l7 7-7 7"
          />
        </svg>
      </Link>
    )}
  </div>
)

const FourKeyPoints = () => (
  <section className="py-24 px-6 bg-offWhite">
    <div className="container mx-auto">
      {/* Section Header */}
      <div className="text-center mb-16">
        <div
          className="inline-flex items-center px-4 py-2 rounded-full text-xs font-semibold uppercase tracking-wider mb-4"
          style={{
            background:
              'linear-gradient(135deg, rgba(99, 91, 255, 0.1) 0%, rgba(17, 239, 227, 0.1) 100%)',
            color: '#635bff'
          }}
        >
          Why Choose Us
        </div>
        <h2 className="text-4xl font-bold text-navy mb-4">
          Services that delight and deliver
        </h2>
        <p className="text-lg text-textSecondary max-w-2xl mx-auto">
          Experience dental care designed around your needs, with modern
          technology and a compassionate team.
        </p>
      </div>

      {/* Feature Grid */}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <FeatureCard
          icon={CalendarIcon}
          iconColor="#635bff"
          title="Convenient Appointments"
          description="Walk-in & next-day appointments welcome! We're your emergency dentists. Our team is always here for you!"
          link="/appointments"
          linkText="Schedule now"
        />

        <FeatureCard
          icon={HeartIcon}
          iconColor="#ff80b5"
          title="Family Services"
          description="We take pride in serving all ages. Treatment plans are tailored accordingly, caring for even your youngest family member."
        />

        <FeatureCard
          icon={DocumentIcon}
          iconColor="#11efe3"
          title="Easy Insurance"
          description="No need to wait for your insurance reimbursement! We send your insurance claim directly for you."
        />

        <FeatureCard
          icon={NavigateIcon}
          iconColor="#33c27f"
          title="Great Location"
          description="Conveniently located on Highway 213 in Oregon City with easy access and ample parking."
        />
      </div>
    </div>
  </section>
)

export default FourKeyPoints
